var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"container"},[_c('Header'),_c('Editor',{staticClass:"editor"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }